export const STANDARD_THEME_KEYS = [
  'standard50',
  'standard100',
  'standard150',
  'standard250',
  'standard400',
  'standard500',
  'mustVisitCities500',
  'animals500',
  'naturalWonders500'
] as const

export const ARCHIVED_THEME_KEYS = [
  'soccer50',
  'pokemon151',
  'pokemon100',
  'pokemon250',
  'pokemon350',
  'pokemon500',
  'mtgrevised',
  'mtg100',
  'mtg250',
  'mtg350',
  'mtg500',
  'unesco100',
  'unesco250',
  'unesco350',
  'unesco500',
  'castle100',
  'castle250',
  'castle350',
  'castle500',
  'inventions100',
  'inventions250',
  'inventions350',
  'inventions500',
  'compounds100',
  'compounds250',
  'compounds350',
  'compounds500',
  'cosmos100',
  'cosmos250',
  'cosmos350',
  'cosmos500',
  'backpacker100',
  'backpacker250',
  'backpacker350',
  'backpacker500',
  'tourist100',
  'tourist250',
  'tourist326',
  'artists100',
  'artists250',
  'artists350',
  'artists500',
  'rockroll100',
  'rockroll250',
  'rockroll350',
  'rockroll432',
  'turningpoints100',
  'turningpoints250',
  'turningpoints350',
  'turningpoints500',
  'architecture100',
  'architecture250',
  'architecture350',
  'architecture500',
  'botanical100',
  'botanical250',
  'botanical350',
  'botanical500',
  'marine100',
  'marine250',
  'marine350',
  'marine500'
] as const

export const THEME_KEYS = [...STANDARD_THEME_KEYS, ...ARCHIVED_THEME_KEYS] as const

export type ThemeKey = (typeof THEME_KEYS)[number]

export type StandardThemeKey = (typeof STANDARD_THEME_KEYS)[number]
